import { render, staticRenderFns } from "./PracticeFeed.vue?vue&type=template&id=27091810&scoped=true&"
import script from "./PracticeFeed.vue?vue&type=script&lang=js&"
export * from "./PracticeFeed.vue?vue&type=script&lang=js&"
import style0 from "./PracticeFeed.vue?vue&type=style&index=0&id=27091810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27091810",
  null
  
)

/* custom blocks */
import block0 from "./PracticeFeed.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports